import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  ListItemButton,
  Stack,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { memo } from 'react';
import VendorIcon from '../../../../../assets/VendorIcon';
import UnlinkedChip from '../../../../../components/UnlinkedChip';

const StyledList = styled(List)(() => ({
  display: 'block',
}));

const ListVendors = ({ vendors, selectedVendor, onSelectedVendor }) => {
  const getVendorName = vendor => vendor?.rootCompany?.name;

  const ellipsis = { overflow: 'hidden', textOverflow: 'ellipsis' };

  return (
    <StyledList>
      {vendors?.map(vendor => {
        const isInactive = vendor.active === false;

        const secondaryContent = isInactive ? (
          <Stack direction="row" spacing={1} alignItems="center" sx={ellipsis}>
            <span style={ellipsis}>{vendor.name}</span>
            <UnlinkedChip />
          </Stack>
        ) : (
          vendor.name
        );

        return (
          <ListItem
            key={vendor.companyId}
            sx={{
              bgcolor: 'background.paper',
              marginBottom: '1rem',
              borderRadius: '4px',
              boxShadow: '0px 0px 0px 0.6px #E0E0E0',
            }}
            secondaryAction={
              <Checkbox
                inputProps={{
                  'aria-labelledby': `vendor_${vendor.companyId}`,
                }}
                checked={selectedVendor?.companyId === vendor.companyId}
                onChange={() => onSelectedVendor(vendor)}
                disabled={isInactive || undefined}
              />
            }
            disablePadding
          >
            <ListItemButton
              sx={{
                height: '4rem',
                maxWidth: '100%',
              }}
              disabled={isInactive || undefined}
              onClick={() => onSelectedVendor(vendor)}
            >
              <ListItemIcon>
                <VendorIcon />
              </ListItemIcon>
              <ListItemText
                id={`vendor_${vendor.companyId}`}
                primary={getVendorName(vendor)}
                sx={{ textWrap: 'nowrap' }}
                secondary={secondaryContent}
                secondaryTypographyProps={{
                  component: isInactive ? 'div' : 'span',
                  sx: ellipsis,
                }}
                primaryTypographyProps={{
                  variant: 'subtitle1',
                  sx: ellipsis,
                }}
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </StyledList>
  );
};

export default memo(ListVendors);
